export default __webpack_public_path__ + "static/media/10ed5c7934054adbf1ee2729880992e2.png";